import { render, staticRenderFns } from "./myPractice.vue?vue&type=template&id=45275dcd&scoped=true"
import script from "./myPractice.vue?vue&type=script&lang=js"
export * from "./myPractice.vue?vue&type=script&lang=js"
import style0 from "./myPractice.vue?vue&type=style&index=0&id=45275dcd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45275dcd",
  null
  
)

export default component.exports